module.exports = __webpack_public_path__ + "images/RBL_EMIc6af0306e6d68457d74db5ae1a1314fd.jpg";